/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { ImagesViewerModalProps } from "../pages/authenticated/exams/ExamDetailsContainer";
import React, { FC, useState } from "react";
import ViewImage from "./Viewer/ViewImage";
import { ImageItem } from "./ImageItem";
import ViewerModal from "./Viewer/ViewerModal";
import { NoResult } from "./NoResult";

interface IImageViewer {
  images: Array<ImagesViewerModalProps>;
  studyId?: string;
  downloadSeries: (
    studyId?: string,
    seriesId?: string,
    instanceId?: string
  ) => void;
  downloadInstance: (
    studyId?: string,
    seriesId?: string,
    instanceId?: string,
    frame?: number
  ) => void;
  downloadByUrl?: (url: string) => void;
}

export const ImageViewer: FC<IImageViewer> = ({
  images,
  studyId,
  downloadSeries,
  downloadInstance,
  downloadByUrl,
}) => {
  const [showViewerModal, setShowViewerModal] = useState(false);
  const [selectedSeries, setSelectedSeries] = useState(null);
  const [currentSeriesIndex, setCurrentSeriesIndex] = useState(-1);
  return (
    <>
      {showViewerModal && (
        <ViewerModal
          show={showViewerModal}
          seriesImagesViewerModal={images}
          seriesId={selectedSeries?.id}
          downloadInstance={downloadInstance}
          downloadByUrl={downloadByUrl}
          studyId={studyId}
          onClose={() => {
            // close and reset.
            setShowViewerModal(false);
            setCurrentSeriesIndex(-1);
            setSelectedSeries(null);
          }}
          currentSeriesIndex={currentSeriesIndex}
          title={selectedSeries?.name}
        />
      )}
      <div className="row">
        {images.map((img, idx) => {
          return (
            <>
              <div
                className="col-lg-3 col-md-6 col-xs-12 m-b-sm cursor-pointer"
                key={img.id}
                onClick={() => {
                  setCurrentSeriesIndex(idx + 1);
                  setTimeout(() => {
                    setShowViewerModal(true);
                    setSelectedSeries(img);
                  }, 100);
                }}
              >
                <div className="img-wrapper flex-direction-column d-flex flex-center">
                  <div className="position-absolute description">
                    {img.name}
                  </div>
                  <ViewImage src={img.src} />
                </div>
                <ImageItem
                  seriesId={img.id}
                  idx={idx + 1}
                  total={images.length}
                  studyId={studyId}
                  download={downloadSeries}
                  downloadByUrl={downloadByUrl}
                />
              </div>
            </>
          );
        })}

        {images.length === 0 && <NoResult type="Images" />}
      </div>
    </>
  );
};
